import { BehaviourItem } from '../../coaching-tags/models/behaviour.coaching.model';
import { SubBehaviourItem } from '../../coaching-tags/models/subbehaviour.coaching.model';
import { composeTagIdentifierNext } from '../../coaching-tags/tags/tags.model';
import { ObservationCommitDialogItem } from '../observation-commit-dialog/observation-commit-dialog.component';

import { ObservationFormValue } from './observation-form-value.model';

export function determineCommitItems(
    formValue: ObservationFormValue,
    isSavedObservation: boolean,
    behaviours: BehaviourItem[],
    subBehaviours: SubBehaviourItem[],
): ObservationCommitDialogItem[] {
    const result: ObservationCommitDialogItem[] = [];
    if (!formValue || !formValue.tagGroups) {
        return result;
    }

    const touchedFocusContainers = formValue.tagGroups
        .filter((e) => isSavedObservation || e.trackingChanged)
        .map((e) => e.trackingId);
    formValue.tagGroups.forEach((e) => {
        if (e.behaviourId == null) {
            return;
        }

        const identifier = composeTagIdentifierNext(e);
        // eslint-disable-next-line @typescript-eslint/prefer-includes
        const touched =
            touchedFocusContainers &&
            // eslint-disable-next-line @typescript-eslint/prefer-includes
            touchedFocusContainers.indexOf(e.trackingId) !== -1;

        const behaviour = behaviours.find((ee) => ee.id === e.behaviourId);
        const subBehaviour = subBehaviours.find(
            (ee) => ee.id === e.subBehaviourId,
        );

        result.push({
            ID: identifier,
            BehaviourId: e.behaviourId,
            SubBehaviourId: e.subBehaviourId,
            BehaviourText: behaviour ? behaviour.name : null,
            SubBehaviourText: subBehaviour ? subBehaviour.name : null,
            Status: null, // assigned later
            trackingId: e.trackingId,
            commitmentId: null, // assigned later
            touched,
        });
    });

    return result;
}
